export default "__VITE_ASSET__CzKIwEj8__"